module.exports = __webpack_public_path__ + "static/logoLivereactingBlack-256740870b0f90dfacf358e900544277.png";